module.exports = __webpack_public_path__ + "static/media/cash.8cb1b34f.png";